export const PHONE_DISPLAY = "0 362 431 66 66";
export const PHONE_TEL = "tel:+903624316666";
export const EMAIL = "info@neco.com.tr";
export const ADDRESS = "Neco Plaza, Samsun Fuar İçi 55030 İlkadım / Samsun";
export const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=Neco+Plaza+Samsun+Fuar";
export const WA_URL = `https://wa.me/905324756461?text=${encodeURIComponent(
  "Merhaba, Neco Plaza salonları hakkında bilgi ve rezervasyon için yazıyorum."
)}`;

export const IMAGES = {
  hero: "/images/hero.jpg",
  sultan1: "/images/sultan1-1.jpg",
  sultan1Gallery: ["/images/sultan1-2.jpg", "/images/sultan1-3.jpg"],
  sultan2: "/images/sultan2-1.jpg",
  sultan2Gallery: ["/images/sultan2-2.jpg", "/images/sultan2-3.jpg", "/images/sultan2-4.jpg"],
  bahce: "/images/bahce-1.jpg",
  bahceGallery: ["/images/bahce-2.jpg", "/images/bahce-3.jpg", "/images/bahce-4.jpg"],
  teras: "/images/teras-1.jpg",
  terasGallery: ["/images/teras-2.jpg"],
  catering:
    "https://images.unsplash.com/photo-1731941465921-eb4285693713?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  corporate:
    "https://images.unsplash.com/photo-1523580494863-6f3031224c94?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cake: "https://images.pexels.com/photos/15591269/pexels-photo-15591269.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const HALLS = [
  {
    id: "sultan1",
    name: "Sultan I Balo Salonu",
    tagline: "Hayallerinizi Sultan I'de yansıtın",
    image: IMAGES.sultan1,
    gallery: IMAGES.sultan1Gallery,
    description:
      "Samsun'un en güzel noktasında yer alan Sultan I, bütün ihtişamı ve eşsiz atmosferiyle misafirlerini en iyi şekilde ağırlıyor. 9 katlı düğün pastası, havai fişek organizasyonu, kar show, sis show, orkestra ve gelin-damat için özel ikramlar.",
    stats: [
      { label: "Banket", value: "450" },
      { label: "Toplantı", value: "750" },
      { label: "Kokteyl", value: "900" },
    ],
    area: "400 m²",
    features: ["9 Katlı Düğün Pastası", "Havai Fişek Show", "Kar & Sis Show", "Orkestra", "Gelin-Damat İkramları"],
  },
  {
    id: "sultan2",
    name: "Sultan II Balo Salonu",
    tagline: "En büyüğü sizin olsun",
    image: IMAGES.sultan2,
    gallery: IMAGES.sultan2Gallery,
    description:
      "Aşkınız çok büyükse, büyük davetleriniz ve büyük planlarınız varsa; en güzel düğünler, düğün kadar görkemli nişanlar ve asla unutulmayacak sünnetler için Samsun'da daha büyük bir seçenek yok.",
    stats: [
      { label: "Banket", value: "650" },
      { label: "Toplantı", value: "1100" },
      { label: "Kokteyl", value: "1400" },
    ],
    area: "605 m²",
    features: ["Görkemli Davetler", "Sütunsuz Geniş Salon", "Otomatik Açılır Sahne", "Özel Işıklandırma", "Jeneratör Sistemi"],
  },
  {
    id: "bahce",
    name: "Sultan Bahçe Davet Salonu",
    tagline: "Geniş hayallere ferah detaylar",
    image: IMAGES.bahce,
    gallery: IMAGES.bahceGallery,
    description:
      "Kişi sayısına göre şekillendirilebilen, Osmanlı motifleriyle dekore edilmiş kendine özel konuma sahip Sultan Bahçe'de tüm davet organizasyonlarınız için emin ellerdesiniz.",
    stats: [
      { label: "Banket", value: "550" },
      { label: "Toplantı", value: "1300" },
      { label: "Kokteyl", value: "2000" },
    ],
    area: "936 m²",
    features: ["Osmanlı Motifleri", "Yüksek Tavan", "Esnek Oturma Düzeni", "Bağımsız Fuaye", "Kanallı Klima"],
  },
  {
    id: "teras",
    name: "Sultan Teras Davet Salonu",
    tagline: "Gün batımına uzanan deniz manzarası",
    image: IMAGES.teras,
    gallery: IMAGES.terasGallery,
    description:
      "Yaz aylarında gün batımına uzanan deniz manzaralı konumu, neoklasik çizgileri ve tercihinize göre üstü açılıp kapanabilen tavanıyla size özel bir davet deneyimi.",
    stats: [
      { label: "Banket", value: "300" },
      { label: "Kokteyl", value: "550" },
      { label: "Tiyatro", value: "400" },
    ],
    area: "495 m²",
    features: ["Deniz Manzarası", "Açılır-Kapanır Tavan", "Gün Batımı Konumu", "Neoklasik Tasarım", "Açık Hava Davetleri"],
  },
];

export const MENUS = [
  { name: "İkram Paketi 1", items: "Patates kroket · Peynirli puf böreği · Su" },
  { name: "İkram Paketi 2", items: "Patates kroket · Peynirli puf böreği · Kuru pasta (tatlı-tuzlu) · Su" },
  { name: "Kuru Pasta Paketi", items: "Kuru pasta (tatlı-tuzlu) · Cips · Su" },
  { name: "Kokteyl Menü", items: "Patates kroket · Peynirli puf böreği · Kokteyl sosis · Havuçlu marul salatası · Kanepeler" },
  { name: "Et Menü", items: "Dana rosto · Tereyağlı pilav · Patates kroket · Peynirli puf böreği · Mevsim salatası · İçecek" },
  { name: "Piliç Menü", items: "Piliç sultan sarma · Tereyağlı pilav · Patates kroket · Peynirli puf böreği · Mevsim salatası · İçecek" },
];

export const HALL_OPTIONS = [
  "Sultan I Balo Salonu",
  "Sultan II Balo Salonu",
  "Sultan Bahçe Davet Salonu",
  "Sultan Teras Davet Salonu",
];
